import Vue from 'vue'
import Router from 'vue-router'
import Integral from '@/components/Integral'
import Share from '@/components/Share'
import Recommend from '@/components/Recommend'
import Help from '@/components/Help'
import Service from '@/components/Service'
import Download from '@/components/Download'
import Lottery from '@/components/Lottery'
import Welcome from '@/components/Welcome'
import ActivityNewBook from '@/components/ActivityNewBookMonth11'
import CouponCode from '@/components/CouponCode'
import ShareMonthlyCompetition from '@/components/ShareMonthlyCompetition'
import activityTurntable from '@/components/activityTurntable'
import activityTurntableAfter from '@/components/activityTurntableAfter'
import activityTurntableAfterReceive from '@/components/activityTurntableAfterReceive'
import Consultation from '@/components/Consultation'
import lotteryLogin from '@/components/lotteryLogin'
import pageWeb from '@/components/pageWeb'







Vue.use(Router)

const router = new Router({
  routes: [{
      path: '/',
      name: '欢迎',
      component: Welcome
    }, {
      path: '/integral',
      name: '如何使用积分',
      component: Integral
    }, {
      path: '/share',
      name: '分享',
      component: Share
    }, {
      path: '/recommend',
      name: '海渡职校',
      component: Recommend
    }, {
      path: '/help',
      name: '帮助中心',
      component: Help
    }, {
      path: '/service',
      name: '服务使用协议',
      component: Service
    }, {
      path: '/download',
      name: '资源下载',
      component: Download
    }, {
      path: '/FSHI034DA90F546732800E2059E29D25AC2',
      name: '大转盘',
      component: Lottery
    }, {
      path: '/activity/newbook11',
      name: '11月新书来袭',
      component: ActivityNewBook
    }, {
      path: '/couponGetPage',
      name: '海渡优惠码',
      component: CouponCode
    }, {
      path: '/shareMonthlyCompetition',
      name: '海渡月度赛分享',
      component: ShareMonthlyCompetition
    },
    {
      path: '/activity/turntable',
      name: '领券活动',
      component: activityTurntable
    },
    {
      path: '/activity/turntable/after',
      name: '分享领券活动',
      component: activityTurntableAfter
    },
    {
      path: '/activity/turntable/after/Receive',
      name: '使用优惠券',
      component: activityTurntableAfterReceive
    },
    {
      path: '/Consultation',
      name: '资讯详情',
      component: Consultation
    },
    {
      path: '/activity/login',
      name: '大转盘',
      component: lotteryLogin
    },
    {
      path: '/page/web',
      name: '详情页面',
      component: pageWeb
    }
  ]
});

router.afterEach(transition => {
  if (transition.name) {
    document.title = transition.name;
    let u = navigator.userAgent;
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isiOS) {
      let i = document.createElement('iframe');
      i.src = 'http://m.baidu.com/favicon.ico';
      i.style.display = 'none';
      i.onload = function () {
        setTimeout(function () {
          i.remove();
        }, 0);
      };
      document.body.appendChild(i);
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js